/**
 * Подпись исчерпанного лимита (макет 8-5).
 *
 * Одна на панель и на строку ⌘K: обе говорят человеку одно и то же, и
 * разошедшиеся формулировки читались бы как разные ограничения.
 */
import { i18n } from '@/i18n'

import type { AssistantQuota } from './stream'

export const limitNotice = (quota: AssistantQuota | null, locale: string): string => {
  const resets = quota?.resets_at

  // Момент обнуления считает сервис: сутки лимита идут по его часовому поясу,
  // и посчитанная здесь полночь была бы чужой. Не прислал — обещаем «завтра»,
  // а не выдуманное время.
  if (!resets) return i18n.global.t('assistant.limit.later')

  const at = new Date(resets)

  if (Number.isNaN(at.getTime())) return i18n.global.t('assistant.limit.later')

  return i18n.global.t('assistant.limit.at', {
    time: at.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' }),
  })
}
